// Hook odpowiedzialny za pobranie menu admina

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

type IItem = {
  name: string;
  symbol: string;
  dynamic_page: string;
  component_name?: string;
  url_redirect?: string;
  params_list?: string;
};

export type ICategory = {
  name: string;
  symbol: string;
  icon?: string;
  items?: IItem[];
};

// typ zwracanych danych
export interface IResponse {
  navigation_definition: {
    categories: ICategory[];
  };
}

const getPanelNavigationDefinition = (): Promise<IResponse> =>
  axios.get('dynamicUI/navigation_definition');

export const useGetPanelNavigationDefinition = (options?: UseQueryOptions<IResponse, IError>) =>
  useQuery<IResponse, IError>(['dynamicUI-menu'], () => getPanelNavigationDefinition(), options);
